import { useMemo } from "react";
import { Pencil } from "lucide-react";
import { ListContainer } from "@/ui/components/shared/ListItem";
import { useStore } from "@/state/legacy_module_api";
import { parseJwt } from "@/state/legacy_module_api";

type NoteToSelfProps = {
  navPause?: boolean;
  onSelect?: (args: { senderId: string; receiverId: string }) => void;
};

const NoteToSelfListItem = ({ navPause, onSelect }: NoteToSelfProps) => {
  // Use direct store selector for proper reactivity
  const apiToken = useStore((s) => s.apiToken);
  const myUserId = useMemo(() => {
    if (!apiToken) return undefined;
    return parseJwt(apiToken).user_id;
  }, [apiToken]);

  const handleClick = async () => {
    if (!myUserId) {
      console.warn("[NoteToSelfListItem] myUserId not available yet");
      return;
    }
    if (navPause) {
      await new Promise((resolve) => setTimeout(resolve, 500));
    }
    onSelect?.({ senderId: myUserId, receiverId: myUserId });
  };

  // Don't render if user is not logged in
  if (!myUserId) {
    return null;
  }

  return (
    <ListContainer>
      <div
        className="flex items-center gap-4 px-4 py-3 cursor-pointer hover:bg-muted/50"
        onClick={handleClick}
      >
        <div className="w-10 h-10 rounded-full bg-muted flex items-center justify-center">
          <Pencil className="w-5 h-5 text-muted-foreground" />
        </div>
        <div className="flex-1">
          <p className="font-medium">Note to Self</p>
        </div>
        <span className="text-sm">✅</span>
      </div>
    </ListContainer>
  );
};

export default NoteToSelfListItem;
